import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UserService } from "src/app/shared/services/user.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})

export class TransportService extends ApiBaseService {

  constructor(
    private configService: ConfigService,
    private http: HttpClient,
    private us: UserService
  ) {
    super(us);
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-time-key',
        'SessionId': this.userService.sessionId
      }),
    };
    this.baseUrl = `${this.configService.config.timeUrl}/api/transport`;
  }

  saveMultipleCarriedArticles(carriedArticlesToAdd: any[], carriedArticlesToUpdate: any[]): Observable<any> {
    var expenses = {
      CarriedArticlesToAdd: carriedArticlesToAdd,
      CarriedArticlesToUpdate: carriedArticlesToUpdate
    };

    return this.http.post<any>(this.baseUrl + '/TransportCarriedArticleSaveMultipleTimes', expenses, this.httpOptions);
  }

  saveMultipleEquipments(equipmentsToAdd: any[], equipmentsToUpdate: any[]): Observable<any> {
    var equipments = {
      EquipmentsToAdd: equipmentsToAdd,
      EquipmentsToUpdate: equipmentsToUpdate
    };

    return this.http.post<any>(this.baseUrl + '/TransportEquipmentsSaveMultipleTimes', equipments, this.httpOptions);
  }

  createTransportCollection(date: Date, employeeId: number, primaryProjectId: number, secondaryProjectId: number, customRef: string, comment: string): Observable<any> {
    const request = {
      Date: date,
      EmployeeId: employeeId,
      PrimaryProjectId: primaryProjectId,
      SecondaryProjectId: secondaryProjectId,
      Comment: comment,
      CustomerReference: customRef
    };

    const httpOptions = { headers: new HttpHeaders({ "Content-Type": "application/json", "APIKEY": "ams-direct-api-project-key", "SessionId": this.userService.sessionId }) };
    return this.http.post<any>(`${this.configService.config.projectUrl}/api/transportcollections/create`, request, httpOptions);
  }

  deleteTransportCollection(id: number) {
    const httpOptions = { headers: new HttpHeaders({ "Content-Type": "application/json", "APIKEY": "ams-direct-api-project-key", "SessionId": this.userService.sessionId }) };
    return this.http.delete<any>(`${this.configService.config.projectUrl}/api/transportcollections/delete?id=${id}`, httpOptions);
  }
}
